<template>

     <v-dialog v-model="dialogBesoinTrx" fullscreen hide-overlay transition="dialog-bottom-transition" >
            <Loading :value="loading" ></Loading>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title >BESOINS VEHICULES POUR DES TRAVAUX</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

        
        <!-- TAB Projet -->
        <v-layout row >
             <v-flex sm12 ml-1 mr-1 mt-1>
                 <v-card  >
                 <el-tabs v-model="onglet" type="border-card" @tab-click="handleTabClick(onglet)" >
                    <el-tab-pane label="Besoins â valider">
                        <!-- LISTE besoins travaux a valider-->
                        <ListeBesoinTravaux @reloadBesoinValider="loadBesoinVehAvalider()"  ></ListeBesoinTravaux>
                        <!--  LISTE besoins travaux a valider-->
                      <br>
                   
                    </el-tab-pane>
                    <el-tab-pane label="Vehicules affectés à des travaux" > 
                        <!-- LISTE vehicule  affecter -->
                        <!-- <v-layout row>
                            <v-flex xs12 mt-2>
                                <data-tables mt-3 ml-1 mr-1  ref="multipleTable"  :data="listeBesoinsVehValid" style="width:100%;">
                                    <el-table-column prop="id" label="ID" align="center" >
                                         <template slot-scope="scope">
                                             ID-{{scope.row.id}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="dateC" label="DATE" align="center" ></el-table-column>
                                    <el-table-column prop="vehicule" label="VEHICULE ATTRIBUE" align="center"></el-table-column>
                                    <el-table-column prop="periode" label="PERIODE" align="center">
                                        <template slot-scope="scope">
                                             {{scope.row.periode}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="produit" label="VEHICULE DEMANDE" align="center"></el-table-column>
                                    <el-table-column prop="qte" label="QUANTITE" align="center"></el-table-column>
                                    <el-table-column prop="duree" label="DUREE(Jours)" align="center"></el-table-column>
                                    <el-table-column prop="prix" label="MONTANT/(J)" align="center"></el-table-column>
                                    <el-table-column prop="total" label="COUT TOTAL" align="center">
                                        <template slot-scope="scope">
                                             {{scope.row.total}}
                                         </template>
                                    </el-table-column>
                                    <el-table-column prop="demandeur" label="DEMANDEUR" align="center"></el-table-column>
                                    <el-table-column prop="responsables" label="VALIDE PAR PROJET/LOGISTIQUE" align="center"></el-table-column>
                                    <el-table-column prop="libelle" label="PROJET/CHANTIER/TRAVAUX" align="center"></el-table-column>
                                   
                                </data-tables>
                            </v-flex>
                        </v-layout> -->
                        <!-- LISTE vehicule  affecter -->

                        <VehiculeBesoin :listeBesoinsVeh =listeBesoinsVehValid ></VehiculeBesoin>


                    </el-tab-pane>
                </el-tabs>
                 </v-card>
            </v-flex>
        </v-layout>
         <!--FIN  TAB Projet -->
            </v-card>

     </v-dialog>

   

</template>

<script>


import Loading from '@/components/Loading'
import ListeBesoinTravaux from '@/components/besoin/listeBesoinTravaux';
import VehiculeBesoin from '@/components/besoin/VehiculeBesoin';

export default {
    components:{ Loading,ListeBesoinTravaux,VehiculeBesoin},
    name: "BesoinTravaux",
         props: {
             show:{
                 type: Boolean
             } ,            
         },
        data() 
        {
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                dialogBesoinTrx: false,
                loading: false,
                onglet: "0",              
            //ONGLET BESOINS TRAVAUX A VALIDER
              listeVehicules: [],
        
            //ONGLET LISTE VEHICULE AFFECTE
            listeBesoinsVehValid:[]               
          }
        },
        methods: {        
        //ONGE=LET VEHICULE AFFECTE
         loadBesoinVehValider(){
            this.loading = true
            let url = this.domaine + 'besoin/vehicule/valider'
            this.$http.get(url).then(response => {            
                this.listeBesoinsVehValid = response.body.besoins;
                console.log("liste besoin valider ",response.body.besoins)
                this.loading = false;
              
            }, error =>{
                this.loading = false;
                this.$message.error('Echec lors du chargement des vehicules affectés au besoins')
            });
        },        
        loadBesoinVehAvalider() {
            this.loading = true;
            let url = this.domaine + "besoin/vehicule";
            this.$http.get(url).then(response => {
              this.listeBesoinsVeh = response.body.besoins;
              this.nbBesoins = response.body.besoins.length;
              this.loading = false;
            });
          },
          handleTabClick(tab){              
              switch (tab) {
                case "0":
                    console.log("liste vehicule")
                    this.loadBesoinVehValider();
                    break;
              case "1":            
                    this.loadBesoinVehValider();                                  
                break;
              
              default:
                this.loadBesoinVehAvalider()
              break;
              }
          },
           closeDialog(){
                this.listeVehicules.splice(0);
                this.$emit('close')
            },

        },

        watch: {
            show : function(newValue, oldvalue){
               this.dialogBesoinTrx= newValue;
               
                if(newValue == true){
                    this.onglet = "0";
                    //this.loadListeVehicule()
                }
            }
        }
    

    
}
</script>


// WEBPACK FOOTER //
// src/components/besoin/besoinTravaux.vue